import React, { useState, useEffect } from "react";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./style.scss";

const Navigation = () => {
  const [show, setShow] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [navBlack, setNavBlack] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const listenToScroll = () => {
    let heightToHideFrom = 300;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      setNavBlack(true);
    } else {
      setNavBlack(false);
    }
  };

  return (
    <>
      <header id="header" className={`${show || showSearch ? "open" : ""}`}>
        <div className={`wrap_fixed ${navBlack ? "active" : ""}`}>
          <p className="icon_home">
            <a href="https://shiso.or.jp/">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path d="M575.8 255.5C575.8 273.5 560.8 287.6 543.8 287.6H511.8L512.5 447.7C512.5 450.5 512.3 453.1 512 455.8V472C512 494.1 494.1 512 472 512H456C454.9 512 453.8 511.1 452.7 511.9C451.3 511.1 449.9 512 448.5 512H392C369.9 512 352 494.1 352 472V384C352 366.3 337.7 352 320 352H256C238.3 352 224 366.3 224 384V472C224 494.1 206.1 512 184 512H128.1C126.6 512 125.1 511.9 123.6 511.8C122.4 511.9 121.2 512 120 512H104C81.91 512 64 494.1 64 472V360C64 359.1 64.03 358.1 64.09 357.2V287.6H32.05C14.02 287.6 0 273.5 0 255.5C0 246.5 3.004 238.5 10.01 231.5L266.4 8.016C273.4 1.002 281.4 0 288.4 0C295.4 0 303.4 2.004 309.5 7.014L564.8 231.5C572.8 238.5 576.9 246.5 575.8 255.5L575.8 255.5z"></path>
              </svg>
            </a>
          </p>

          <div
            id="nav_toggle"
            className="nav_toggle"
            onClick={() => setShow(true)}
          >
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <p className="icon_search" onClick={() => setShowSearch(true)}>
            <i className="fas fa-search"></i>
          </p>
        </div>

        <div className={`wrap_menu ${show ? "active" : ""}`}>
          <div
            id="nav_toggle2"
            className="nav_toggle"
            onClick={() => setShow(false)}
          >
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <p className="ttl_nav">Menu</p>

          <nav className="g_nav">
            <ul className="ul_g_nav">
              <li>
                <a href="https://shiso.or.jp/attraction/#attraction01">
                  宍粟市について
                </a>
              </li>
              <li>
                <a href="https://shiso.or.jp/therapy">森林セラピー</a>
              </li>
              <li>
                <a href="https://shiso.or.jp/attraction/#attraction02">
                  魅力の4エリア
                </a>
              </li>
              <li>
                <a href="https://shiso.or.jp/therapy_bike">セラピーバイク</a>
              </li>
              <li>
                <a href="https://shiso.or.jp/attraction/#attraction03">
                  しそうの四季
                </a>
              </li>
              <li>
                <a href="https://shiso.or.jp/famous_mountain_top">
                  天空回廊
                  <br className="sp" />
                  宍粟50名山
                </a>
              </li>
              <li>
                <a href="https://shiso.or.jp/attraction/#attraction04">
                  しそう森林王国
                  <br className="sp" />
                  観光協会について
                </a>
              </li>
              <li>
                <a href="https://shiso.or.jp/recommended_route">モデルコース</a>
              </li>
              <li>
                <a href="https://shiso.or.jp/document">
                  各種申請書
                  <br className="sp" />
                  ダウンロード
                </a>
              </li>
              <li>
                <a href="https://shiso.or.jp/highlights">見どころMAP</a>
              </li>
              <li>
                <a href="https://shiso.or.jp/pamphlet">
                  観光
                  <br className="sp" />
                  パンフレット
                </a>
              </li>

              <li>
                <a href="https://shiso.or.jp/booking">体験・宿泊予約</a>
              </li>
            </ul>
          </nav>

          <div className="wrap_menu2">
            <ul className="ul_menu">
              <li>
                <a href="https://shiso.or.jp/">トップページ</a>
              </li>
              <li>
                <a href="https://shiso.or.jp/privacy_policy">
                  プライバシーポリシー
                </a>
              </li>
            </ul>

            <div className="la_select">
              <p className="ttl_la">Language</p>
              <div>
                <div
                  id="google_language_translator"
                  className="default-language-ja"
                >
                  <div className="skiptranslate goog-te-gadget" dir="ltr">
                    <div id=":0.targetLanguage">
                      <select
                        className="goog-te-combo"
                        aria-label="Language Translate Widget"
                      >
                        <option value="">Select Language</option>
                        <option value="zh-CN">Chinese (Simplified)</option>
                        <option value="zh-TW">Chinese (Traditional)</option>
                        <option value="en">English</option>
                        <option value="fr">French</option>
                        <option value="de">German</option>
                        <option value="id">Indonesian</option>
                        <option value="it">Italian</option>
                        <option value="ko">Korean</option>
                        <option value="ne">Nepali</option>
                        <option value="pt">Portuguese</option>
                        <option value="th">Thai</option>
                        <option value="vi">Vietnamese</option>
                      </select>
                    </div>
                    Powered by
                    <span>
                      <a
                        className="VIpgJd-ZVi9od-l4eHX-hSRGPd"
                        href="https://translate.google.com"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src="https://www.gstatic.com/images/branding/googlelogo/1x/googlelogo_color_42x16dp.png"
                          width="37px"
                          height="14px"
                          alt="Google Translate"
                        />
                        Translate
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`wrap_search_menu ${showSearch ? "active" : ""}`}>
          <span className="inner_search_menu"></span>
          <div
            id="nav_search_toggle"
            className="nav_toggle "
            onClick={() => setShowSearch(false)}
          >
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <p className="ttl_nav">Search</p>

          <p className="txt_search">キーワードで検索</p>

          <form method="get" id="searchform" action="https://shiso.or.jp">
            <p className="search">
              <input type="text" name="s" id="s" />
              <button type="submit">
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </p>
          </form>
          <p className="txt_search txt_cat_search">見どころスポットを検索</p>

          <ul className="ul_nav_cat">
            <li className="li_all">
              <a href="https://shiso.or.jp/highlights">
                <span>すべて</span>
              </a>
            </li>
            <li className="li_nature_flower">
              <a href="https://shiso.or.jp/highlights_cat/nature_flower">
                <span>自然・花</span>
              </a>
            </li>
            <li className="li_shopping">
              <a href="https://shiso.or.jp/highlights_cat/shopping">
                <span>買い物</span>
              </a>
            </li>
            <li className="li_activity">
              <a href="https://shiso.or.jp/highlights_cat/activity">
                <span>アクティビティ</span>
              </a>
            </li>
            <li className="li_lodging_hot_spring">
              <a href="https://shiso.or.jp/highlights_cat/lodging_hot_spring">
                <span>宿泊・温泉</span>
              </a>
            </li>
            <li className="li_gourmet">
              <a href="https://shiso.or.jp/highlights_cat/gourmet">
                <span>食事・グルメ</span>
              </a>
            </li>
            <li className="li_culture_history">
              <a href="https://shiso.or.jp/highlights_cat/culture_history">
                <span>文化・歴史</span>
              </a>
            </li>
          </ul>
        </div>
      </header>

      <div className="wrap_keyimage wrap_keyimage2">
        <div className="wrap_keyimage_h2">
          <h2 className="ttl_h2_keyimage">
            <span>Recommended Spots &amp; Event</span>
            <br />
            おすすめスポット＆ <br className="sp" />
            イベント案内
          </h2>
        </div>
      </div>
    </>
  );
};

export default Navigation;
